import React, { useEffect, useState } from "react";
import "./CreateCampaignTemplate.css";
import "./nameCampaign.css";
import { previewDevices, tabContent } from "./GoogleAutomationConstants";
import img from "../../assets/icons/leadTemplate.png";
import {
  useFormik,
  Formik,
  Form,
  Field,
  FieldArray,
  ErrorMessage,
} from "formik";
import * as Yup from "yup";
import Select, { components } from "react-select";

const validationSchema = Yup.object().shape({
  AdsName: Yup.string().required("Ad Name is required"),
  budgetIncrease: Yup.boolean().required("Budget is required"),
  facebookPage: Yup.object().nullable().required("Facebook Page is required"),
  instagramAccount: Yup.object()
    .nullable()
    .required("Instagram Account is required"),
  placement: Yup.string()
    .oneOf(["SingleImage", "Carousel"])
    .required("Placement is required"),
  multiAdvertiserAds: Yup.boolean().required(
    "Multi Advertiser Ads selection is required"
  ),
  mediaLocation: Yup.object().required("Media location is required"),
  adSetup: Yup.object().nullable().required("Ad setup is required"),
  destination: Yup.boolean().required("Destination is required"),
  languages: Yup.boolean().required("Languages are required"),

  // Validation for Dynamic Fields (Arrays)
  urlParameters: Yup.array()
    .of(Yup.string().required("Each URL parameter is required"))
    .min(1, "At least one URL parameter is required"),

  primaryText: Yup.array()
    .of(Yup.string().required("Each primary text field is required"))
    .min(1, "At least one primary text is required"),
});

const AdsName = ({
  setIsFormFiveValid,
  setFormFiveValue,
  formFiveValue,
  submitFinalFormData,
  reactSelectStyles,
}) => {
  const [isToggled, setIsToggled] = useState(false);
  const [isPartAdToggled, setIsPartAdToggled] = useState(false);
  const [selected, setSelected] = useState("advantage");
  const [addTextOption, setAddTextOption] = useState(1);
  const [addBuildUrlOption, setAddBuildUrlOption] = useState(1);
  const [isAddDestinationToggled, setIsAddDestinationToggled] = useState(false);
  const [isLanguagesToggled, setIsLanguagesToggled] = useState(false);
  const [selectedFormat, setSelectedFormat] = useState("SingleImage");
  const [previewType, setPreviewType] = useState("pc");

  const handleToggle = () => {
    setIsToggled((prev) => !prev);
  };
  const handlePartAdToggle = () => {
    setIsPartAdToggled((prev) => !prev);
  };
  const handleDestinationToggle = () => {
    setIsAddDestinationToggled((prev) => !prev);
  };
  const handleLanguageToggle = () => {
    setIsLanguagesToggled((prev) => !prev);
  };

  const initialValues = {
    AdsName: formFiveValue.AdsName || "",
    budgetIncrease: formFiveValue.budgetIncrease || false,
    facebookPage: formFiveValue.facebookPage || null,
    instagramAccount: formFiveValue.instagramAccount || null,
    placement: formFiveValue.placement || "SingleImage",
    multiAdvertiserAds: formFiveValue.multiAdvertiserAds || false,
    mediaLocation: formFiveValue.mediaLocation || "",
    adSetup: formFiveValue.adSetup || null,
    destination: formFiveValue.destination || false,
    languages: formFiveValue.languages || false,
    urlParameters: formFiveValue.urlParameters || [""],
    primaryText: formFiveValue.primaryText || [""],
  };

  return (
    <div className="adsname-container">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          console.log("Form submitted with values:", values);
          submitFinalFormData();
        }}
      >
        {({ errors, touched, isValid, dirty, values, setFieldValue }) => {
          if (dirty) {
            setIsFormFiveValid(isValid && dirty);
            setFormFiveValue(values);
          }

          return (
            <Form className="adsname-container">
              <div className="left-adsname-box h-[90vh] w-[50%] overflow-scroll pt-5 pb-40">
                <div className="create-form-item" style={{ marginTop: "10px" }}>
                  <div className="f-14" style={{ fontWeight: "bold" }}>
                    Ad name
                  </div>
                  <div
                    className="common-input-container"
                    data-label="Adset Name"
                  >
                    {/* <input type="text" placeholder="eg Adglobal360 Festive" /> */}
                    <Field
                      name="AdsName"
                      type="text"
                      placeholder="eg Adglobal360 Festive"
                    />
                    <ErrorMessage
                      name="AdsName"
                      component="div"
                      className="error text-red-500 text-xs"
                    />
                  </div>
                </div>
                <div className="create-form-item">
                  <div>
                    <div className="f-14" style={{ fontWeight: "bold" }}>
                      Partnership ad{" "}
                      <label
                        className="preview-toggle"
                        style={{ marginBottom: "0px" }}
                      >
                        {/* <input
                  type="checkbox"
                  checked={isPartAdToggled}
                  onChange={handlePartAdToggle}
                />{" "} */}
                        <Field
                          type="checkbox"
                          checked={isPartAdToggled}
                          onChange={handlePartAdToggle}
                          name="budgetIncrease"
                        />
                        <ErrorMessage
                          name="budgetIncrease"
                          component="div"
                          className="error-message text-red-500 text-xs"
                        />

                        <span className="preview-slider" />
                      </label>
                    </div>
                    <p className="description">
                      Run ads with creaters, brands and other businesses. These
                      ads will feature both identities in the header.
                    </p>
                    <p className="link">Learn more.</p>
                  </div>
                </div>
                <div className="create-form-item">
                  <div>
                    <div className="f-14" style={{ fontWeight: "bold" }}>
                      Indentity
                    </div>
                    <p className="description">
                      Choose the facebook Page and Instagram Account that this
                      ad will be associated with.
                    </p>
                  </div>
                </div>
                <div>
                  <div
                    className="f-14"
                    style={{ fontWeight: "bold", marginBottom: "2px" }}
                  >
                    Facebook Page
                  </div>
                  <p className="description" style={{ marginBottom: "20px" }}>
                    Choose the page you want to promote.
                  </p>
                  <div className="common-type-container" data-label="Page Name">
                    {/* <Select
              placeholder="Page Name"
              options={[
                { label: "Highest Volume", value: "Highest" },
                { label: "Lowest Volume", value: "Lowest" },
              ]}
              styles={reactSelectStyles}
            /> */}

                    <Select
                      styles={reactSelectStyles}
                      placeholder="Page Name"
                      options={[
                        { label: "Highest Volume", value: "Highest" },
                        { label: "Lowest Volume", value: "Lowest" },
                      ]}
                      onChange={(selectedOptions) =>
                        setFieldValue("facebookPage", selectedOptions)
                      }
                      value={values.facebookPage}
                    />
                    <ErrorMessage
                      name="facebookPage"
                      component="div"
                      className="text-red-500 text-xs"
                    />
                  </div>
                  <p className="description" style={{ marginTop: "3px" }}>
                    Select a Page at the ad set level for this ad, you must
                    select a Page to represent your business at the ad set
                    level. The same Page will automatically be selected for your
                    ad.
                  </p>
                  <p className="link" style={{ marginBottom: "20px" }}>
                    Select Page
                  </p>
                </div>
                <div>
                  <div
                    className="f-14"
                    style={{ fontWeight: "bold", marginBottom: "12px" }}
                  >
                    Instagram Account
                  </div>
                  <div className="create-form-item">
                    <div
                      className="common-type-container"
                      data-label="Use Page"
                    >
                      {/* <Select
                placeholder="Use Facebook Page"
                options={[
                  { label: "Highest Volume", value: "Highest" },
                  { label: "Lowest Volume", value: "Lowest" },
                ]}
                styles={reactSelectStyles}
              /> */}
                      <Select
                        styles={reactSelectStyles}
                        placeholder="Use Facebook Page"
                        options={[
                          { label: "Highest Volume", value: "Highest" },
                          { label: "Lowest Volume", value: "Lowest" },
                        ]}
                        onChange={(selectedOptions) =>
                          setFieldValue("instagramAccount", selectedOptions)
                        }
                        value={values.instagramAccount}
                      />
                      <ErrorMessage
                        name="instagramAccount"
                        component="div"
                        className="text-red-500 text-xs"
                      />
                    </div>
                    <div>OR</div>
                    <button className="continue-button f-14">Connect </button>
                  </div>
                </div>
                <div>
                  <div
                    className="f-14"
                    style={{
                      fontWeight: "bold",
                      marginBottom: "12px",
                    }}
                  >
                    Ad Setup
                  </div>
                  <div className="create-form-item">
                    <div
                      className="common-type-container"
                      data-label="Create Ad"
                    >
                      {/* <Select
                placeholder="Create Ad"
                options={[
                  { label: "India", value: "Highest" },
                  { label: "USA", value: "Lowest" },
                ]}
                styles={reactSelectStyles}
              /> */}
                      <Select
                        styles={reactSelectStyles}
                        placeholder="Create Ad"
                        options={[
                          { label: "India", value: "Highest" },
                          { label: "USA", value: "Lowest" },
                        ]}
                        onChange={(selectedOptions) =>
                          setFieldValue("adSetup", selectedOptions)
                        }
                        value={values.adSetup}
                      />
                      <ErrorMessage
                        name="adSetup"
                        component="div"
                        className="text-red-500 text-xs"
                      />
                    </div>
                  </div>
                </div>
                <div style={{ marginBottom: "10px" }}>
                  <div
                    className="f-16"
                    style={{
                      fontWeight: "bold",
                    }}
                  >
                    Format
                  </div>
                  <p className="description">
                    Choose how you would like to structure your ad.
                  </p>
                </div>
                <div
                  className="radio-container"
                  style={{ flexDirection: "column", marginBottom: "20px" }}
                >
                  <label
                    className={`radio-label ${
                      selected === "SingleImage" ? "selected" : ""
                    }`}
                  >
                    {/* <input
              type="radio"
              name="placement"
              value="advantage"
              checked={selected === "SingleImage"}
              onChange={() => setSelected("SingleImage")}
            /> */}

                    <Field
                      type="radio"
                      name="placement"
                      value="SingleImage"
                      checked={values.placement === "SingleImage"}
                      onChange={() => setFieldValue("placement", "SingleImage")}
                    />
                    <ErrorMessage
                      name="placement"
                      component="div"
                      className="error-message text-red-500 text-xs"
                    />

                    <div>
                      <div className="f-14">
                        <span>Single image or video</span>{" "}
                      </div>
                      <p>
                        One image or video, or a slideshow with multiple images.
                      </p>
                    </div>
                  </label>

                  <label
                    className={`radio-label ${
                      selected === "Carousel" ? "selected" : ""
                    }`}
                  >
                    {/* <input
              type="radio"
              name="placement"
              value="manual"
              checked={selected === "Carousel"}
              onChange={() => setSelected("Carousel")}
            /> */}

                    <Field
                      type="radio"
                      name="placement"
                      value="Carousel"
                      checked={values.placement === "Carousel"}
                      onChange={() => setFieldValue("placement", "Carousel")}
                    />
                    <ErrorMessage
                      name="placement"
                      component="div"
                      className="error-message text-red-500 text-xs"
                    />

                    <div>
                      <div className="f-14">Carousel</div>
                      <p>Two or more scrollable images or videos.</p>
                    </div>
                  </label>

                  <label
                    className={`radio-label ${
                      selected === "Collection" ? "selected" : ""
                    }`}
                  >
                    {/* <input
              type="radio"
              name="placement"
              value="manual"
              checked={selected === "Collection"}
              onChange={() => setSelected("Collection")}
            /> */}

                    <Field
                      type="radio"
                      name="placement"
                      value="Collection"
                      checked={values.placement === "Collection"}
                      onChange={() => setFieldValue("placement", "Collection")}
                    />
                    <ErrorMessage
                      name="placement"
                      component="div"
                      className="error-message text-red-500 text-xs"
                    />

                    <div>
                      <div className="f-14">Collections</div>
                      <p>
                        Group of items that open in a full screen mobile
                        experience.
                      </p>
                    </div>
                  </label>
                </div>
                <div className="create-form-item">
                  <div>
                    <div
                      className="f-14"
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      Multi-advertiser ads
                      <label
                        className="preview-toggle"
                        style={{ marginBottom: "0px" }}
                      >
                        {/* <input
                  type="checkbox"
                  checked={isPartAdToggled}
                  onChange={handlePartAdToggle}
                />{" "} */}
                        <Field
                          type="checkbox"
                          name="multiAdvertiserAds"
                          checked={isPartAdToggled}
                          onChange={handlePartAdToggle}
                        />{" "}
                        <ErrorMessage
                          name="multiAdvertiserAds"
                          component="div"
                          className="error-message text-red-500 text-xs"
                        />
                        <span className="preview-slider" />
                      </label>
                    </div>
                    <p className="description">
                      Your ads can appear alongside with other ads in the same
                      ad unit to help people discover products and services from
                      businesses that are personalized to them. Your ad creative
                      amy be resized ro cropped to fit the ad unit.
                    </p>
                    <p className="link">Learn about the multi-advertiser ad</p>
                  </div>
                </div>
                <div className="create-form-item">
                  <div>
                    <div style={{ marginBottom: "10px" }}>
                      <div
                        className="f-14"
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        Ad Creative
                      </div>
                      <p className="description">
                        Select and optimize your ad text, media and
                        enhancements.
                      </p>
                    </div>
                    <div>
                      <div
                        className="f-14"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "12px",
                        }}
                      >
                        Media
                      </div>
                      <div className="create-form-item">
                        <div
                          className="common-type-container"
                          data-label="Location"
                        >
                          {/* <Select
                    placeholder="select"
                    options={[
                      { label: "India", value: "Highest" },
                      { label: "USA", value: "Lowest" },
                    ]}
                    styles={reactSelectStyles}
                  /> */}
                          <Select
                            styles={reactSelectStyles}
                            placeholder="select"
                            options={[
                              { label: "India", value: "Highest" },
                              { label: "USA", value: "Lowest" },
                            ]}
                            onChange={(selectedOptions) =>
                              setFieldValue("mediaLocation", selectedOptions)
                            }
                            value={values.mediaLocation}
                          />
                          <ErrorMessage
                            name="mediaLocation"
                            component="div"
                            className="text-red-500 text-xs"
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div
                        className="f-12"
                        style={{
                          fontWeight: "bold",
                          marginBottom: "12px",
                        }}
                      >
                        Primary Text
                      </div>
                      {/* <div
                className="create-form-item"
                style={{ flexDirection: "column", alignItems: "flex-start" }}
              >
                <div className="common-input-container" data-label="*">
                  <input
                    placeholder="Tell people what your ad is all about."
                    style={{ border: "1px solid lightgray", width: "350px" }}
                  />
                </div>
                {Array.from({ length: addTextOption }).map((_, index) => (
                  <div className="common-input-container" key={index}>
                    <input
                      placeholder="Enter another option for primary text."
                      style={{ border: "1px solid lightgray", width: "350px" }}
                    />
                  </div>
                ))}
                <p
                  className="link"
                  style={{ textDecoration: "none" }}
                  onClick={() => setAddTextOption((prev) => prev + 1)}
                >
                  + Add text option
                </p>
              </div> */}

                      <FieldArray name="primaryText">
                        {({ push, remove, form }) => (
                          <div
                            className="create-form-item"
                            style={{
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                          >
                            {form.values.primaryText.map((_, index) => (
                              <div
                                key={index}
                                className="common-input-container"
                              >
                                <Field
                                  name={`primaryText[${index}]`}
                                  placeholder={
                                    index === 0
                                      ? "Tell people what your ad is all about."
                                      : "Enter another option for primary text."
                                  }
                                  style={{
                                    border: "1px solid lightgray",
                                    width: "350px",
                                  }}
                                />
                                {/* {index > 0 && (
            <button type="button" onClick={() => remove(index)}>❌</button>
          )} */}
                              </div>
                            ))}
                            <p
                              className="link"
                              style={{
                                textDecoration: "none",
                                cursor: "pointer",
                              }}
                              onClick={() => push("")}
                            >
                              + Add text option
                            </p>
                          </div>
                        )}
                      </FieldArray>
                    </div>
                  </div>
                </div>
                <div className="create-form-item">
                  <div>
                    <div
                      className="f-14"
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      Add a destination
                      <label
                        className="preview-toggle"
                        style={{ marginBottom: "0px" }}
                      >
                        {/* <input
                  type="checkbox"
                  checked={isAddDestinationToggled}
                  onChange={handleDestinationToggle}
                />{" "} */}
                        <Field
                          type="checkbox"
                          name="destination"
                          checked={isAddDestinationToggled}
                          onChange={handleDestinationToggle}
                        />{" "}
                        <ErrorMessage
                          name="destination"
                          component="div"
                          className="error-message text-red-500 text-xs"
                        />
                        <span className="preview-slider" />
                      </label>
                    </div>
                    <p className="description">
                      If you add a destination, you can send people immediately
                      after they tap or click your ad to a website, a fullscreen
                      experience or a call. If you don't they w'll be sent to
                      your Facebook Page or Instargam Account.
                    </p>
                  </div>
                </div>
                <div className="create-form-item">
                  <div>
                    <div className="f-14" style={{ fontWeight: "bold" }}>
                      Event details . (Optional)
                    </div>
                    <p className="description">
                      Include event details for your ad. Your ad will display a
                      title, start or end time, and a reminder button so your
                      audience can get reminders about the events.
                    </p>
                    <p className="description">
                      <svg
                        style={{ marginRight: "5px" }}
                        className="w-6 h-6 text-gray-800 dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="22"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke="orange"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="2"
                          d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                        />
                      </svg>
                      For the identity of your ad, you must select an Instagram
                      account to include event details.
                    </p>
                  </div>
                </div>
                <div className="create-form-item">
                  <div>
                    <div
                      className="f-14"
                      style={{
                        fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      Languages
                      <label
                        className="preview-toggle"
                        style={{ marginBottom: "0px" }}
                      >
                        {/* <input
                  type="checkbox"
                  checked={isLanguagesToggled}
                  onChange={handleLanguageToggle}
                />{" "} */}
                        <Field
                          type="checkbox"
                          name="languages"
                          checked={isLanguagesToggled}
                          onChange={handleLanguageToggle}
                        />{" "}
                        <ErrorMessage
                          name="languages"
                          component="div"
                          className="error-message text-red-500 text-xs"
                        />
                        <span className="preview-slider" />
                      </label>
                    </div>
                    <p className="description">
                      If you add a destination, you can send people immediately
                      after they tap or click your ad to a website, a fullscreen
                      experience or a call. If you don't they w'll be sent to
                      your Facebook Page or Instargam Account.
                    </p>
                  </div>
                </div>
                <div
                  className="search-input-container"
                  data-label="Languages"
                  style={{ width: "250px" }}
                >
                  <input
                    type="text"
                    style={{
                      height: "38px",
                      border: "1px solid lightgray",
                    }}
                    placeholder="Search the languages of your customers"
                  />
                  <svg
                    style={{ position: "absolute", left: "7px", top: "20%" }}
                    className="w-6 h-6 text-gray-800 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="20"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#3b82f6"
                      strokeLinecap="round"
                      strokeWidth="2"
                      d="m21 21-3.5-3.5M17 10a7 7 0 1 1-14 0 7 7 0 0 1 14 0Z"
                    />
                  </svg>
                </div>
                <div className="good-for mb-20">
                  {["English", "Hindi"].map((item, index) => (
                    <span key={index} className="good-for-item f-12">
                      {item}{" "}
                      <span style={{ padding: "2px 0", cursor: "pointer" }}>
                        X
                      </span>
                    </span>
                  ))}
                </div>
                <div className="create-form-item">
                  <div>
                    <div className="f-14" style={{ fontWeight: "bold" }}>
                      Tracking
                    </div>
                    <p className="description mb-20">
                      Track events datasets that contains the conversions your
                      ad might motivate. The dataset that contains the
                      conversion selected for the ad account will be tracked by
                      default.
                    </p>
                    <p className="description  f-14 f-bold mb-20">
                      Website events
                    </p>
                    <p className="description f-14 f-bold mb-20">App events</p>
                    <p className="description f-14 f-bold">Offline events</p>
                  </div>
                </div>
                <p className="description">
                  <svg
                    style={{ marginRight: "5px" }}
                    className="w-6 h-6 text-gray-800 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="22"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="orange"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M12 13V8m0 8h.01M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    />
                  </svg>
                  You no longer need to select a domain for your web events.
                  There's nothing you need to do for this change.
                </p>
                <p className="link mb-20">Learn more</p>
                <div>
                  <div
                    className="f-14"
                    style={{
                      fontWeight: "bold",
                      marginBottom: "12px",
                    }}
                  >
                    Url Parameter (Optional)
                  </div>
                  {/* <div
            className="create-form-item"
            style={{ flexDirection: "column", alignItems: "flex-start" }}
          >
            {Array.from({ length: addBuildUrlOption }).map((_, index) => (
              <div
                className="common-input-container"
                key={index}
                data-label="parameters"
              >
                <input
                  placeholder="Key1=[value1]&key2=[value2]"
                  style={{ border: "1px solid lightgray", width: "350px" }}
                />
              </div>
            ))}
            <p
              className="link"
              style={{ textDecoration: "none" }}
              onClick={() => setAddBuildUrlOption((prev) => prev + 1)}
            >
              + Build a url parameter
            </p>
          </div> */}

                  <div
                    className="create-form-item"
                    style={{
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <FieldArray name="urlParameters">
                      {({ push, remove }) => (
                        <>
                          {values.urlParameters.map((_, index) => (
                            <div
                              key={index}
                              className="common-input-container"
                              data-label="parameters"
                            >
                              <Field
                                name={`urlParameters[${index}]`}
                                placeholder="Key1=[value1]&key2=[value2]"
                                style={{
                                  border: "1px solid lightgray",
                                  width: "350px",
                                }}
                              />
                              {/* <button
                        type="button"
                        onClick={() => remove(index)}
                        style={{ marginLeft: "10px" }}
                      >
                        ❌
                      </button> */}
                              {errors.urlParameters?.[index] &&
                                touched.urlParameters?.[index] && (
                                  <div className="error">
                                    {errors.urlParameters[index]}
                                  </div>
                                )}
                            </div>
                          ))}
                          <p
                            className="link"
                            style={{
                              textDecoration: "none",
                              cursor: "pointer",
                            }}
                            onClick={() => push("")}
                          >
                            + Build a URL parameter
                          </p>
                        </>
                      )}
                    </FieldArray>
                  </div>
                </div>
              </div>

              <div className="right-adsname-box">
                <div className="ads-name-preview-header">
                  <label className="preview-toggle">
                    <input
                      type="checkbox"
                      checked={isToggled}
                      onChange={handleToggle}
                    />{" "}
                    <span className="preview-slider" />
                  </label>

                  <button className="preview-button preview">
                    <svg
                      className="w-6 h-6 text-white dark:text-white"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M16 4h4m0 0v4m0-4-5 5M8 20H4m0 0v-4m0 4 5-5"
                      />
                    </svg>
                    <span>Advanced preview</span>
                  </button>

                  <button className="preview-icon-button">
                    <span className="preview-icon">
                      <svg
                        style={{ color: "black" }}
                        className="w-6 h-6 text-white dark:text-white"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M14.516 6.743c-.41-.368-.443-1-.077-1.41a.99.99 0 0 1 1.405-.078l5.487 4.948.007.006A2.047 2.047 0 0 1 22 11.721a2.06 2.06 0 0 1-.662 1.51l-5.584 5.09a.99.99 0 0 1-1.404-.07 1.003 1.003 0 0 1 .068-1.412l5.578-5.082a.05.05 0 0 0 .015-.036.051.051 0 0 0-.015-.036l-5.48-4.942Zm-6.543 9.199v-.42a4.168 4.168 0 0 0-2.715 2.415c-.154.382-.44.695-.806.88a1.683 1.683 0 0 1-2.167-.571 1.705 1.705 0 0 1-.279-1.092V15.88c0-3.77 2.526-7.039 5.967-7.573V7.57a1.957 1.957 0 0 1 .993-1.838 1.931 1.931 0 0 1 2.153.184l5.08 4.248a.646.646 0 0 1 .012.011l.011.01a2.098 2.098 0 0 1 .703 1.57 2.108 2.108 0 0 1-.726 1.59l-5.08 4.25a1.933 1.933 0 0 1-2.929-.614 1.957 1.957 0 0 1-.217-1.04Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </span>
                  </button>
                </div>
                <div
                  className="create-form-item"
                  style={{ padding: "10px", justifyContent: "center" }}
                >
                  <div
                    className="toggle-type-buttons"
                    style={{
                      gap: "0px",
                      border: "none",
                      padding: "0",
                      overflow: "hidden",
                      borderRadius: "4px",
                    }}
                  >
                    {previewDevices.map((device) => (
                      <button
                        style={{
                          backgroundColor:
                            previewType === device.type ? "#007bff" : "#e6f0ff",
                          borderRadius: "0px",
                          color:
                            previewType === device.type ? "#e6f0ff" : "#007bff",
                        }}
                        key={device.type}
                        className={`toggle-button ${
                          previewType === device.type ? "active" : ""
                        }`}
                        onClick={() => setPreviewType(device.type)}
                      >
                        {device.code}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default AdsName;
